// extracted by mini-css-extract-plugin
export var searchHeader = "_9x-0";
export var searchHeaderDark = "_9x-1";